<template>
    <MainContent :title="'Venta de abonos ' + configuracion.simpatizantes">
        <template v-slot:header>
            <h3 class="card-title text-uppercase mb-3">{{ configuracion.simpatizantes }}</h3>
        </template>
        <template v-slot:content>
            <div class="row">
                <div class="col-12" id="inicio">
                    <TitleComponent :title="'1. Nº de ' + configuracion.simpatizantes" subtitle="" />
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="metodo_pago">Número de {{ configuracion.simpatizantes }}</label>
                        <multiselect v-model="n_simpatizantes" :options="[1, 2, 3, 4, 5, 6, 7, 8]" name="n_simpatizantes" :allowEmpty="false" id="n_simpatizantes" :show-labels="false" />
                    </div>
                </div>
                <div class="col-12 mb-3 text-right">
                    <Button @click.prevent="finalizarPasoUno">Continuar</Button>
                </div>
                <div class="col-12" v-if="datos" id="datos">
                    <hr />
                    <TitleComponent :title="'2. Datos de los ' + configuracion.simpatizantes" subtitle="" />
                </div>
                <div class="col-12 p-3 pb-0" v-if="datos">
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <div class="row">
                            <b-col md="6" sm="12" v-for="(abonado, index) in datos_abonados" :key="index">
                                <div class="card">
                                    <div class="card-header bg-secondary">
                                        <span class="text-capitalize">{{ configuracion.simpatizante }} - {{ ++index }}</span>
                                    </div>
                                    <div class="card-body">
                                        <div>
                                            <FormInput label="Nombre" :name="'nombre' + index" rules="required" v-model="abonado.nombre" :disabled="resumen || compra_finalizada"/>
                                        </div>
                                        <div>
                                            <FormInput label="Apellidos" :name="'apellidos' + index" rules="required" v-model="abonado.apellidos" :disabled="resumen || compra_finalizada"/>
                                        </div>
                                        <div>
                                            <FormInput label="Dni" :name="'dni' + index" rules="required" v-model="abonado.dni" :disabled="resumen || compra_finalizada"/>
                                        </div>
                                        <div>
                                            <FormInput label="Fecha de nacimiento" type="date" :name="'fecha_nacimiento' + index" rules="required" min="1900-01-01" v-model="abonado.fecha_nacimiento" :disabled="resumen || compra_finalizada"/>
                                        </div>
                                        <div>
                                            <FormInput label="Email" type="email" :name="'email' + index" rules="required" v-model="abonado.email" :disabled="resumen || compra_finalizada"/>
                                        </div>
                                        <div>
                                            <FormInput label="Teléfono" :name="'telefono' + index" rules="required" v-model="abonado.telefono" :disabled="resumen || compra_finalizada"/>
                                        </div>
                                        <div>
                                            <FormInput label="Provincia" :name="'provincia' + index" rules="required" v-model="abonado.provincia" :disabled="resumen || compra_finalizada"/>
                                        </div>
                                        <div>
                                            <FormInput label="Localidad" :name="'localidad' + index" rules="required" v-model="abonado.localidad" :disabled="resumen || compra_finalizada"/>
                                        </div>
                                        <div>
                                            <FormInput label="Domicilio" :name="'domicilio' + index" rules="required" v-model="abonado.domicilio" :disabled="resumen || compra_finalizada"/>
                                        </div>
                                        <div>
                                            <FormInput label="CP/ZIP CODE" :name="'cp' + index" rules="required" v-model="abonado.codigo_postal" :disabled="resumen || compra_finalizada"/>
                                        </div>
                                        <template v-if="permisos['venta.descuento']">
                                            <div class="col-12 p-0 form-group">
                                                <label for="descuento">Descuento en %</label>
                                                <ValidationProvider :name="'descuento_total' + index" rules="required" v-slot="{ errors }">
                                                    <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="descuento" v-model="abonado.descuento_aplicado" @change="abonado.descuento_integro = 0" :disabled="resumen || compra_finalizada">
                                                        <option value="0">Sin descuento</option>
                                                        <option v-for="(descuento, index) in configuracion.descuento_aplicado" :key="index" :value="descuento.valor">{{ descuento.label }}</option>
                                                    </select>
                                                </ValidationProvider>
                                            </div>
                                            <div class="col-12 p-0 form-group">
                                                <label for="nombre">Descuento en €</label>
                                                <ValidationProvider :name="'descuento en €' + index" rules="required|double" v-slot="{ errors }">
                                                    <input :disabled="abonado.descuento_aplicado !='0' || resumen || compra_finalizada" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Descuento en €" v-model="abonado.descuento_integro" />
                                                </ValidationProvider>
                                            </div>
                                        </template>
                                        <div class="col-12 p-0">
                                            <div class="form-group">
                                                <label for="descuento">Selecciona el tipo de abono</label>
                                                <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                                                    <multiselect
                                                        :class="(errors[0] ? 'is-invalid' : '')"
                                                        v-model="abonado.tipo_abono"
                                                        placeholder="Tipo de abono"
                                                        label="descripcion"
                                                        track-by="id"
                                                        :options="precios"
                                                        id="tipo-abono"
                                                        :disabled="resumen || compra_finalizada"
                                                    />
                                                    <span v-if="errors[0]" class="invalid-feedback mb-4 mt-1 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>Seleccione un tipo de abono</b></span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="col-12 p-0" v-if="abonado.tipo_abono">
                                            <div class="form-group">
                                                <label for="descuento">Selecciona tipo de precio</label>
                                                <ValidationProvider :name="'descuento' + index" rules="required" v-slot="{ errors }">
                                                    <multiselect
                                                        :class="(errors[0] ? 'is-invalid' : '')"
                                                        v-model="abonado.descuento"
                                                        placeholder="Descuento"
                                                        label="descripcion"
                                                        track-by="id"
                                                        :options="abonado.tipo_abono.descuentos"
                                                        id="tipo-descuento"
                                                        :disabled="resumen || compra_finalizada"
                                                    />
                                                    <span v-if="errors[0]" class="invalid-feedback mb-4 mt-0 mt-md-3 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>Seleccione un tipo de abono</b></span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </div>
                        <div class="col-12 p-0">
                            <div class="form-group">
                                <label for="metodo_pago">Método de pago</label>
                                <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                                    <multiselect 
                                        v-model="forma_pago" 
                                        :options="metodos_pago"
                                        name="metodo_pago" 
                                        label="nombre"
                                        id="metodo_pago"
                                        data-cy="metodo_pago"
                                        :disabled="resumen || compra_finalizada"
                                    />
                                    <small v-if="errors[0]" class="text-danger">Seleccione un método de pago</small>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="col-12 text-right pr-0">
                            <Button type="submit" name="button" :disabled="loading">CONTINUAR</Button>
                        </div>
                    </ValidationObserver>
                </div>
                <div class="col-12" v-if="resumen" id="resumen">
                    <hr />
                    <TitleComponent title="3. Resumen de la compra" subtitle="" />
                </div>
                <div class="col-12" v-if="resumen">
                    <div class="row">
                        <div v-for="(abonado, index) in datos_abonados" :key="index + 'd'" class="col-12 mt-3">
                            <div class="card bg-light">
                                <div class="card-header">
                                    <strong class="text-primary text-uppercase">{{ configuracion.simpatizantes }} {{ i = index + 1 }} </strong>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-6" :key="index">
                                            <div class="row">
                                                <div class="col-12">
                                                    <span class="h4 text-uppercase"><strong>{{ abonado.nombre }} {{ abonado.apellidos }}</strong></span>
                                                </div>
                                                <div class="col-12">
                                                    <i class="fas fa-id-card"></i> {{ abonado.dni }}
                                                </div>
                                                <div class="col-12">
                                                    <i class="fas fa-envelope"></i> {{ abonado.email }}
                                                </div>
                                                <div class="col-12">
                                                    <i class="fas fa-phone"></i> {{ abonado.telefono }}
                                                </div>
                                                <div class="col-12" v-if="compra_finalizada">
                                                    <Button :href="urls_imprimir[index]" target="blank_">IMPRIMIR ABONO</Button>
                                                </div>
                                            </div>
                                        </div>
                                        <div  class="col-6" :key="index + 'a'">
                                            <div class="row">
                                                <div class="col-12">
                                                    <strong>TIPO DE ABONO</strong>
                                                </div>
                                                <div class="col-12">
                                                    <span class="h3 text-uppercase"><strong>{{ abonado.descuento.descripcion }}</strong></span>
                                                </div>
                                                <div class="col-12">
                                                    <span class="h4" v-if="totalAbono(abonado) == 0"><strong>{{ abonado.descuento.precio_total_taquilla | formatear_precio }}</strong></span>
                                                    <span v-else> <strike class="pr-3">{{ abonado.descuento.precio_total_taquilla | formatear_precio }}</strike>  <strong>{{ totalAbono(abonado) | formatear_precio }}</strong></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <strong v-if="total_descuento == 0">TOTAL: <span class="h1"><strong>{{ total | formatear_precio }}</strong></span></strong>
                            <strong v-else>TOTAL: <span class="h1"><strike class="pr-5">{{ total | formatear_precio }}</strike> <strong>{{ total_descuento | formatear_precio }}</strong></span></strong>
                        </div>
                        <div class="col-12">
                            <strong>FORMA DE PAGO: <span class="h3"><strong>{{ forma_pago.nombre }}</strong></span></strong>
                            <PaymentCalculator class="mb-3" :amountDue="totalPaymentCalculator" v-if="totalPaymentCalculator > 0 && forma_pago.id == 1" @payment-complete="handlePaymentComplete"/>
                        </div>
                        <div class="col-12 text-right" v-if="!compra_finalizada && !loading">
                            <Button name="button" @click.prevent="finalizar" >TERMINAR COMPRA</Button>
                        </div>
                        <div class="col-12" v-if="loading" style="height: 120px">
                            <LoaderComponent />
                        </div>
                        <div class="col-12 text-center" v-if="compra_finalizada">
                            <div class="col-12 txt-lft">
                                <span class="h4 txt-sats">✅ Compra realizada satisfactoriamente.</span>
                            </div>
                            <div class="mt-2">
                                <Button name="button" @click.prevent="reset">EMPEZAR DE NUEVO</Button>
                                <Button name="button" @click.prevent="volver" class="ml-2">VOLVER AL LISTADO</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import MainContent from "../../../components/backend/components/MainContent";
    import PaymentCalculator from '@/components/common/PaymentCalculator';

    export default {
        data() {
            return {
                loading: false,
                metodos_pago: null,
                precios: [],
                resumen: false,
                n_simpatizantes: 1,
                datos: false,
                datos_abonados: [],
                forma_pago: null,
                urls_imprimir: null,
                compra_finalizada: null
            }
        },
        created() {
            this.getPrecios();
            this.metodos_pago = this.teatro.metodos_pago_abonos_bases.slice().filter(metodo_pago => metodo_pago.show_taquilla);

            this.borrarMetodoDePago([5, 8, 9]);
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            total() {
                var total = 0;

                for (var i = 0; i < this.datos_abonados.length; i++) {
                    total = total + parseFloat(this.datos_abonados[i].descuento.precio_total_taquilla);
                }

                return total;
            },
            total_descuento() {
                var total = 0;

                for (var i = 0; i < this.datos_abonados.length; i++) {
                    if(this.datos_abonados[i].descuento_aplicado > 0){
                        total = this.datos_abonados[i].descuento.precio_total_taquilla - (this.datos_abonados[i].descuento.precio_total_taquilla * (this.datos_abonados[i].descuento_aplicado / 100));
                    }
                    if(this.datos_abonados[i].descuento_integro > 0){
                        total = total + (parseFloat(this.datos_abonados[i].descuento.precio_total_taquilla) - parseFloat(this.datos_abonados[i].descuento_integro));
                    }
                }

                return total;
            },
            totalPaymentCalculator() {
                return this.total_descuento === 0 ? this.total : this.total_descuento;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            }, 
        },
        methods: {
            reset() {
                this.resumen = false;
                this.n_simpatizantes = 1;
                this.datos= false;
                this.datos_abonados = [];
                this.forma_pago = {};
                this.urls_imprimir = null;
                this.compra_finalizada = false
                this.$nextTick(function() {
                    this.scrollTo('#inicio');
                });
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.finalizarPasoDos();
                }
            },
            finalizarPasoUno() {
                this.datos_abonados = [];
                for (var i = 0; i < this.n_simpatizantes; i++) {
                    this.datos_abonados.push({
                        descuento_aplicado: "0",
                        descuento_integro: 0,
                    });
                }
                this.datos = true;
                this.$nextTick(function() {
                    this.scrollTo('#datos');
                });
            },
            finalizarPasoDos() {
                this.resumen = true;
                this.$nextTick(function() {
                    this.scrollTo('#resumen');
                });
            },
            getPrecios() {
                const params = {
                    filters : {
                        simpatizantes: true
                    },
                    lista_id: this.$store.getters.getListaId                    
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                    this.precios = res.data;
                });
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            finalizar() {
                this.loading = true;
                const params = {
                    metodo_pago: this.forma_pago,
                    datos_compradores: this.datos_abonados
                };
                this.$store.dispatch(this.config.getVuexAlias('back.simpatizantes.alta'), params).then(res => {
                    this.compra_finalizada = true;
                    this.urls_imprimir = res.data.urls_imprimir;
                    this.loading = false;
                });
            },
            borrarMetodoDePago(idsAEliminar) {
                this.metodos_pago = this.metodos_pago.filter(metodo => !idsAEliminar.includes(metodo.id));
            },
            totalAbono(abono){
                if(abono.descuento_integro){
                    return parseFloat(abono.descuento.precio_total_taquilla) - parseFloat(abono.descuento_integro);
                }

                if(abono.descuento_aplicado != "0"){
                    return parseFloat(abono.descuento.precio_total_taquilla * (abono.descuento_aplicado / 100));
                }

                return 0;
            },
            volver() {
                return this.$router.push({ name: 'back.simpatizantes.index' });
            }
        },
        components: {
            MainContent,
            TitleComponent,
            PaymentCalculator
        }
    }
</script>

<style scoped>
    .txt-sats {
        color: green;
    }

    .txt-lft {
        text-align: center !important;
        margin-top: 24px;
    }

    @media (max-width: 768px) {
        .txt-lft {
            text-align: center !important;
            margin-bottom: 12px;
            display: block;
            float: none;
            padding-left: auto;
        }
    }
</style>
